"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Storage {
    constructor() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.browser = globalThis.browser;
    }
    /**
     * Get the value stored at the given `key`. Will return `null` if unset.
     *
     * @param key
     */
    get(key) {
        if (this.contextIsBrowserApp) {
            return new Promise(resolve => {
                const val = localStorage.getItem(key);
                if (!val) {
                    return resolve(null);
                }
                try {
                    resolve(JSON.parse(val));
                }
                catch (_a) {
                    resolve(val);
                }
            });
        }
        const area = this.browserStorageArea;
        if (!area) {
            return Promise.reject(new Error(Storage.STORAGE_AREA_ERROR));
        }
        return area.get(key).then(result => {
            const val = result[key];
            if (!val) {
                return null;
            }
            try {
                return JSON.parse(val);
            }
            catch (_a) {
                return val;
            }
        });
    }
    /**
     * Store `value` at `key`.
     *
     * @param key
     * @param value
     */
    set(key, value) {
        let preparedValue = value;
        if (typeof value !== 'string') {
            try {
                preparedValue = JSON.stringify(value);
            }
            catch (_a) {
                // Ignore and hope the storage engine handles it.
            }
        }
        if (this.contextIsBrowserApp) {
            return new Promise(resolve => {
                localStorage.setItem(key, preparedValue);
                resolve();
            });
        }
        const area = this.browserStorageArea;
        if (!area) {
            return Promise.reject(new Error(Storage.STORAGE_AREA_ERROR));
        }
        return area.set({ [key]: preparedValue }).then(() => {
            // Do nothing (return `void`) for consistency.
        });
    }
    /**
     * Whether the current execution context is a browser app (in other words, *not* an extension).
     *
     * Determined to be a browser app if either of the following conditions is true:
     *
     * - `globalThis.browser` is undefined
     * - `globalThis.browser` is defined, but lacks a defined `storage` property (Safari only)
     */
    get contextIsBrowserApp() {
        return (typeof this.browser === 'undefined' ||
            typeof this.browser.storage === 'undefined');
    }
    /**
     * Browser storage area, used by web extensions.
     */
    get browserStorageArea() {
        var _a, _b, _c, _d;
        return ((_b = (_a = this.browser) === null || _a === void 0 ? void 0 : _a.storage) === null || _b === void 0 ? void 0 : _b.sync) || ((_d = (_c = this.browser) === null || _c === void 0 ? void 0 : _c.storage) === null || _d === void 0 ? void 0 : _d.local);
    }
}
Storage.STORAGE_AREA_ERROR = 'Failed to determine which storage area is suitable to use.';
exports.default = Storage;
//# sourceMappingURL=Storage.js.map